import type { DriveUnitPortOccupancy } from '../redux/ApplicationSlice';

export function isDriveUnitPortTakenElsewhere(rows: ReadonlyArray<DriveUnitPortOccupancy>, port: number, electronicKey: string): boolean {
  return rows.some((row) => row.driveUnitPort === port && row.electronic !== electronicKey);
}
